module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.6a273c1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard2/assest/font/notosanskr/notokr-medium.woff2
// module id = D2BR
// module chunks = 0